import type { JSX } from 'react';
import { useStore } from 'dg-web-shared/lib/Flux';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import * as LayoutState from '../../../layout/state/LayoutState';
import { texts as helpdeskTexts } from '../i18n/HelpdeskTexts';
import { ResponsiveProperties } from '../../../layout/utils/ResponsiveProperties';
import { columnsVariant } from '../../../layout/utils/columnsVariant';
import { css } from '@emotion/css';
import { paper } from 'dg-web-shared/tb-ui/paper.ts';
import { Colors } from 'dg-web-shared/ui/vars';
import { Typo } from 'dg-web-shared/ui/typo.ts';

export interface HelpdeskTexts {
    title: () => string;
    content: () => JSX.Element;
}

export function Helpdesk() {
    const { storeState } = useStore(store => ({
        layout: new LayoutState.StateSlice(store).state,
    }));
    const { language } = useLanguage();

    const texts = helpdeskTexts[language];
    const responsiveProps = new ResponsiveProperties(storeState);
    return (
        <div
            className={css([
                {
                    background: Colors.white,
                    padding: '24px',
                    marginTop: '32px',
                    ...paper(4),
                },
                columnsVariant(storeState) === 'OneColumn' &&
                    responsiveProps.toString() === 'Mobile' && {
                        borderRadius: 0,
                        ...paper(0),
                    },
            ])}
        >
            <div className={css({ color: Colors.blue, ...Typo.heading2 })}>
                {texts.title()}
            </div>
            <div
                className={css({
                    marginTop: '10px',
                    color: Colors.typo1,
                    ...Typo.body,
                })}
            >
                {texts.content()}
            </div>
        </div>
    );
}
